/**
 * Piezas compartidas para las graficas del sistema (estilo shadcn charts).
 * Uso tipico:
 *   <ChartContainer config={...} className="h-[260px] w-full">
 *     <AreaChart ...>
 *       <ChartTooltip content={<ChartTooltipContent formatter={tipFormatter(LABELS, money)} />} />
 *     </AreaChart>
 *   </ChartContainer>
 */
import React from 'react';

/**
 * Formatter para ChartTooltipContent que mantiene el look shadcn
 * (cuadradito de color + label + valor) pero con el valor formateado
 * (plata, unidades, %...). `labels` mapea dataKey -> texto visible.
 */
export function tipFormatter(
  labels: Record<string, string>,
  fmt: (v: number) => string
) {
  return (value: any, name: any, item: any): React.ReactNode => (
    <>
      <span
        className="h-2.5 w-2.5 shrink-0 rounded-[2px]"
        style={{ background: item?.color || item?.payload?.fill || 'hsl(var(--muted-foreground))' }}
      />
      <div className="flex flex-1 items-center justify-between gap-3 leading-none">
        <span className="text-muted-foreground">{labels[String(name)] || String(name)}</span>
        <span className="font-mono font-medium tabular-nums text-foreground">{fmt(Number(value))}</span>
      </div>
    </>
  );
}

/** Degradado vertical estandar para areas (el look caracteristico de shadcn). */
export function AreaGradient({ id, color }: { id: string; color: string }) {
  return (
    <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
      <stop offset="5%" stopColor={color} stopOpacity={0.5} />
      <stop offset="95%" stopColor={color} stopOpacity={0.05} />
    </linearGradient>
  );
}
